// Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/** @module common-sk/modules/stateReflector */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "stateReflector", {
    enumerable: true,
    get: function() {
        return stateReflector;
    }
});
const _query = /*#__PURE__*/ _interop_require_wildcard(require("./query"));
const _object = /*#__PURE__*/ _interop_require_wildcard(require("./object"));
const _dom = require("./dom");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function stateReflector(getState, setState, replaceState = false) {
    // The default state of the stateHolder. Used to calculate diffs to state.
    const defaultState = _object.deepCopy(getState());
    // Have we done an initial read from the the existing query params.
    let loaded = false;
    // stateFromURL should be called when the URL has changed, it updates
    // the state via setState() and triggers the callback.
    const stateFromURL = ()=>{
        loaded = true;
        const delta = _query.toObject(window.location.search.slice(1), defaultState);
        setState(_object.applyDelta(delta, defaultState));
    };
    // When we are loaded we should update the state from the URL.
    _dom.DomReady.then(stateFromURL);
    // Every popstate event should also update the state.
    window.addEventListener('popstate', stateFromURL);
    // Return a function to call when the state has changed to force reflection into the URL.
    return ()=>{
        // Don't overwrite the query params until we have done the initial load from them.
        if (!loaded) {
            return;
        }
        const new_state = _object.getDelta(getState(), defaultState);
        const old_state = _query.toObject(window.location.search.slice(1), defaultState);
        const new_delta = _object.getDelta(new_state, old_state);
        const old_delta = _object.getDelta(old_state, new_state);
        // Don't push to state if the current URL and the URL to be pushed are equivalent.
        if (Object.keys(new_delta).length > 0 || Object.keys(old_delta).length > 0) {
            const q = _query.fromObject(new_state);
            const url = `${window.location.origin + window.location.pathname}?${q}`;
            if (replaceState) {
                window.history.replaceState(null, '', url);
            } else {
                window.history.pushState(null, '', url);
            }
        }
    };
}
